import { render, staticRenderFns } from "./DadosSmtp.vue?vue&type=template&id=6dffca5c"
import script from "./DadosSmtp.vue?vue&type=script&lang=js"
export * from "./DadosSmtp.vue?vue&type=script&lang=js"
import style0 from "./DadosSmtp.vue?vue&type=style&index=0&id=6dffca5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports